
import appConfig from '../src/app.config.json';

export default {
    name: 'utils',
    Frappe: class Frappe {
        constructor(url){
            this.url = url;
            this.token = '';
            this.headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            // this.stack = <call stack>;
        }

        async get_sales_grand_total(){
            
            await fetch(`${this.url}/api/method/frappeauth_app.authentication.get_sales_grand_total`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':'token 6e970039c52cbd4:f7b04199aade61e'
                }
            })
            .then((res)=>{
                let result =   res.json();   
                alert(result.message.value);
                return result;

            })
            
                //alert("RESP="+res.status);
                
            
        }
        
        async login(email, password){
            //alert("Frappe.login "+email+ " "+ password);
            //alert(this.url);
            //alert(appConfig.frappe_custom_app);
            var body={usr:email,pwd:password};
            let res = await fetch(`${this.url}/api/method/${appConfig.frappe_custom_app}.authentication.login`, {
                method: 'POST',
                headers: this.headers,
                body: JSON.stringify(body)
            })
            let auth = await res.json()
            //alert(res.status + " : "+auth.message.user + " : Tocken : "+auth.message.token);
            //console.log('AUTH', auth)
            //     // confirm auth
            if(auth.message.status_code==200){
                if (auth.message.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('user', JSON.stringify(auth.message.user));
                }
                return auth.message.user;
            } else {
                //this.$popIt.error('Error!', 'Invalid Credentials')
                return Promise.reject(auth.message.text);
                //return new Error([auth.message.text]);
            }
        }
        // get updated headers
        getHeader(){
            let token = JSON.parse(localStorage.frappUser).token;
            this.headers.Authorization = `token ${token}`
            // return this.headers;
        }

        // handleResponse
        async handleResponse(res){
            if(res.status==200){
                let data = await res.json();
                return await {'status_code': res.status, 'data': data.data};
            } else if(res.status==404) {
                // not found
                return {'status_code': res.status, 'text': res.statusText}
            }
        }

        // get_doc
        async get_doc(doctype, docname){
            try {
                this.getHeader();
                let res = await fetch(`${this.url}/api/resource/${doctype}/${docname}`, {
                    method: 'GET',
                    headers: this.headers
                })
                return await this.handleResponse(res);
            } catch (e) {
                //console.log(e)
                alert(e)
            }
        }
        // update doc
        async update_doc(doctype, docname, body){
            try {
                this.getHeader();
                let res = await fetch(`${this.url}/api/resource/${doctype}/${docname}`, {
                    method: 'PUT',
                    headers: this.headers,
                    body: JSON.stringify(body)
                })
                return await this.handleResponse(res);
            } catch (e) {
                //console.log(e)
                alert(e)
            }
        }
        // create doc
        async new_doc(doctype, body){
            try {
                this.getHeader();
                let res = await fetch(`${this.url}/api/resource/${doctype}`, {
                    method: 'POST',
                    headers: this.headers,
                    body: JSON.stringify(body)
                })
                return await this.handleResponse(res);
            } catch (e) {
                //console.log(e)
                alert(e)
            }
        }
        // DELETE doc
        async delete_doc(doctype, docname){
            try {
                this.getHeader();
                let res = await fetch(`${this.url}/api/resource/${doctype}/${docname}`, {
                    method: 'DELETE',
                    headers: this.headers
                })
                return await this.handleResponse(res);
            } catch (e) {
                //console.log(e)
                alert(e)
            }
        }
        // get list
        async get_list(doctype, filters=null){
            try {
                this.getHeader();
                let url = `${this.url}/api/resource/${doctype}`
                if(filters){
                    url = url + '?' + filters;
                }
                // alert(url)
                // if(fields && filters){
                //     url = url + `?filters=${filters}&fields=${fields}`;
                // } else if (fields) {
                //     url = url + `?fields=${fields}`;
                // } else if (filters) {
                //     url = url + `?filters=${filters}`
                // }
                let res = await fetch(url, {
                    method: 'GET',
                    headers: this.headers
                })
                return await this.handleResponse(res);
            } catch (e) {
                //console.log(e)
                alert(e)
            } 
        }

        // get pdf
        async getPDF(
                doctype, docname, format, Standard,
                no_letterhead, letterhead, lang
            ){
            format = format ? format : 'Standard';
            no_letterhead = no_letterhead ? no_letterhead : 1;
            letterhead = letterhead ? letterhead : 'No Letterhead';
            lang = lang ? lang : 'en';

            let url = `${this.url}/api/method/frappe.utils.print_format.download_pdf?doctype=${doctype}&name=${docname}&format=${format}&no_letterhead=${no_letterhead}&letterhead=${letterhead}&settings=%7B%7D&_lang=${lang}`
            // process download
            this.getHeader();
            let res = await fetch(url, {
                method: 'GET',
                headers: this.headers
            })
            if(res.status==200){
                let blob = await res.blob();
                let file = await window.URL.createObjectURL(blob);
                window.location.assign(file);
            } else {
                this.$popIt.error('Error', res.statusText);
            }
        }
    }
}

// export default new Frappe()
